import { ShareLayout } from "@rapid/components/flow/share/Layout";
import { ShareSidebarContent } from "@rapid/components/flow/share/SidebarContent";
import { ShareVisualAreaContent } from "@rapid/components/flow/share/VisualAreaContent";

export const SharePage = () => {
    return (
        <ShareLayout Sidebar={<ShareSidebarContent />} VisualArea={<ShareVisualAreaContent />} />
    );
};
